<template>
  <div>
    <my-header></my-header>

    <div
      v-if="isLoadedNormal"
      class="content-container-level-1"
    >
      <h2>New update offer</h2>

      <form @submit.prevent="createUpdateOfferWithConfirmation">

        <h5>Title</h5>
        <div class="form-group">
          <b-form-input
            id="input-2"
            v-model="title"
            placeholder="Enter title"
            required
            ></b-form-input>
        </div>

        <h5>Image Url <i>(root is {{imageUrlRoot}})</i></h5>
        <div class="form-group">
          <b-form-input
            id="input-2"
            v-model="imageUrl"
            placeholder="Enter image url like 'bp24_patrick23.png'"
            required
            ></b-form-input>
        </div>

        <h5>Icon Url <i>(root is {{iconUrlRoot}})</i></h5>
        <div class="form-group">
          <b-form-input
            id="input-2"
            v-model="iconUrl"
            placeholder="Enter icon url like 'event_bp24_patrick23_icon.png'"
            required
            ></b-form-input>
        </div>

        <h5>Place</h5>
        <div class="form-group">
          <b-form-select
            v-model="selectedPlace"
            :options="optionsPlace"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            ></b-form-select>
        </div>

        <h5>Type</h5>
        <div class="form-group">
          <b-form-select
            v-model="selectedType"
            :options="optionsType"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
            ></b-form-select>
        </div>

        <h5>Platforms</h5>
        <div class="form-group">
          <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selectedPlatforms"
              :options="platforms"
              name="flavour-1"
            ></b-form-checkbox-group>
        </div>

        <div class="mb-4">
          <h5>Start</h5>

          <b-form-datepicker
            v-model="plannedStartDate"
            :min="minPlannedStartDate"
            :start-weekday="MONDAY"
            class="mb-2"
          />

          <time-input
            v-model="plannedStartTime"
          />
        </div>

        <div class="mb-4">
          <h5>Finish</h5>

          <b-form-datepicker
            v-model="plannedFinishDate"
            :min="minPlannedFinishDate"
            :start-weekday="MONDAY"
            class="mb-2"
          />

          <time-input
            v-model="plannedFinishTime"
          />
        </div>

        <div class="mb-3">
          <h5>Duration</h5>
          <p class="mb-3">
            Full duration<br>
            (Duration between start period begin and finish)<br>
            {{durationStr}}
          </p>
        </div>

        <hr>

        <h5>Client version</h5>
        <client-version
          :clientVersionInfo="clientVersionInfo"
          class="mb-2"
        />

        <h6>Client min version</h6>
        <p class="mb-2">
          {{clientMinVersionComment}}
        </p>
        <input class="form-control" v-model="clientMinVersion" required>

        <br>

        <h6>Client max version</h6>
        <p class="mb-2">
          {{clientMaxVersionComment}}
        </p>
        <input class="form-control" v-model="clientMaxVersion" required>

        <hr>

        <b-button :to="{name: 'update_offers'}">Cancel</b-button>
        <b-button type="submit" variant="primary">Create</b-button>
      </form>
    </div>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
/**
 * @typedef { import('../service/confirm.js').ConfirmHandle } ConfirmHandle
 */
import { confirmAction } from '../service/confirm.js';

/**
 * @typedef { import('../model/event.js').PlayerGroupId } PlayerGroupId
 */
import { ClientVersionInfo                   } from '../model/version.js';

import { convertMomentToDataStr              } from '../util.js';
import { convertMomentToTimeStr              } from '../util.js';
import { getDurationStrBetweenMoments        } from '../util.js';
import { convertDataStrAndTimeStrToLocalData } from '../util.js';
import { normalizeVersionStr                 } from '../util.js';

import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import ClientVersion from './ClientVersion.vue';
import TimeInput from './TimeInput.vue';

import { getEnumPlatformBitName  } from '../autogen/bundle.js';
import { getEnumPlatformBitValues  } from '../autogen/bundle.js';

import { getEnumIconPlaceName  } from '../autogen/bundle.js';
import { getEnumIconPlaceValues  } from '../autogen/bundle.js';

import { getEnumUpdateOfferTypeName  } from '../autogen/bundle.js';
import { getEnumUpdateOfferTypeValues  } from '../autogen/bundle.js';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'UpdateOfferAdd',

  components: {
    MyHeader,
    LoadingIndicator,
    ClientVersion,
    TimeInput,
  },

  data() {
    const start = new Date();
    const startDateStr = convertMomentToDataStr(start);
    const startTimeStr = convertMomentToTimeStr(start);

    // By default season duration is 60 hours (2 days 12 hours).
    const DEFAULT_DURATION_HOURS = 60;

    const finish = new Date(start.getTime());
    finish.setHours(finish.getHours() + DEFAULT_DURATION_HOURS);
    const finishDateStr = convertMomentToDataStr(finish);
    const finishTimeStr = convertMomentToTimeStr(finish);

    return {
      MONDAY: 1,

      loadState: LOAD_STATE_INIT,

      /** @type {?ClientVersionInfo} */
      clientVersionInfo: null,

      title: "",
      
      imageUrlRoot: "/assets/announcements/",
      imageUrl: "",
      iconUrlRoot: "/assets/update_offer/icons/",
      iconUrl: "",

      selectedPlace: 0,
      selectedType: 0,

      optionsPlace: function () {
        let _options = [];
        for(let i = 0; i < getEnumIconPlaceValues().length; ++i)
        {
          let value = getEnumIconPlaceValues()[i];
          let text = getEnumIconPlaceName(value);
          _options.push({ name: text, item: value});
        }
        return _options;
      }(),

      optionsType: function () {
        let _options = [];
        for(let i = 0; i < getEnumUpdateOfferTypeValues().length; ++i)
        {
          let value = getEnumUpdateOfferTypeValues()[i];
          let text = getEnumUpdateOfferTypeName(value);
          _options.push({ name: text, item: value});
        }
        return _options;
      }(),

      platforms: function () {
        let _options = [];
        for(let i = 1; i < getEnumPlatformBitValues().length; ++i)
        {
          let value = getEnumPlatformBitValues()[i];
          let text = getEnumPlatformBitName(value);
          _options.push({ text: text, value: value});
        }
        return _options;
      }(),
      selectedPlatforms: [],

      /** @type {?number} */
      type: null,

      /** @type {?SeasonTypeOption[]} */
      typeOptions: null,

      plannedStartDate:     startDateStr,
      minPlannedStartDate:  startDateStr,
      plannedStartTime:     startTimeStr,

      plannedFinishDate:    finishDateStr,
      minPlannedFinishDate: startDateStr,
      plannedFinishTime:    finishTimeStr,

      clientMinVersion: '',
      clientMaxVersion: '',
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },

    /** @returns {?Date} */
    plannedStartMoment() {
      return convertDataStrAndTimeStrToLocalData(this.plannedStartDate, this.plannedStartTime);
    },

    /** @returns {?number} */
    plannedStartSec() {
      const plannedStartMoment = this.plannedStartMoment;
      if(plannedStartMoment === null) {
        return null;
      }

      return Math.floor(plannedStartMoment.getTime() / 1000);
    },

    /** @returns {?Date} */
    plannedFinishMoment() {
      return convertDataStrAndTimeStrToLocalData(this.plannedFinishDate, this.plannedFinishTime);
    },

    /** @returns {?number} */
    plannedFinishSec() {
      const plannedFinishMoment = this.plannedFinishMoment;
      if(plannedFinishMoment === null) {
        return null;
      }

      return Math.floor(plannedFinishMoment.getTime() / 1000);
    },

    /** @returns {?string} */
    durationStr() {
      const plannedStartMoment = this.plannedStartMoment;
      if(plannedStartMoment === null) {
        return null;
      }

      const plannedFinishMoment = this.plannedFinishMoment;
      if(plannedFinishMoment === null) {
        return null;
      }

      return getDurationStrBetweenMoments(plannedStartMoment, plannedFinishMoment);
    },

    /** @returns {?string} */
    clientMinVersionComment() {
      const clientVersionInfo = this.clientVersionInfo;
      if(clientVersionInfo === null) {
        return null;
      }

      if(clientVersionInfo.gameVersion === clientVersionInfo.forcedVersion) {
        let message = '';
        message += 'Client min version of new season must be inside this range. ';
        message += 'Server version and forced version are equal. '
        message += 'Consequently, value ' + clientVersionInfo.gameVersion + ' is the only option for min client version.';
        return message;
      }

      return 'Specify client min version of new season inside this range.';
    },

    clientMaxVersionComment() {
      const clientVersionInfo = this.clientVersionInfo;
      if(clientVersionInfo === null) {
        return null;
      }

      if(clientVersionInfo.gameVersion === clientVersionInfo.forcedVersion) {
        let message = '';
        message += 'Client max version of new season must be inside this range. ';
        message += 'Server version and forced version are equal. '
        message += 'Consequently, value ' + clientVersionInfo.gameVersion + ' is the only option for max client version.';
        return message;
      }

      return 'Specify client max version of new season inside this range.';
    },
  },

  created() {
    this.loadNewUpdateOffer();
  },

  methods: {
    loadNewUpdateOffer() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      HTTP.get('/new_update_offer')
      .then(response => {
        /** @type {NewSeasonInfo} */
        const data = response.data.data;

        const gameVersion = normalizeVersionStr(data.gameVersion);
        if(gameVersion === null) {
          notifier.showError('Loaded gameVersion is invalid.', {sender: this});
          return;
        }

        const forcedVersion = data.forcedVersion;
        this.clientVersionInfo = new ClientVersionInfo(gameVersion, forcedVersion);

        this.clientMinVersion = forcedVersion;
        this.clientMaxVersion = gameVersion;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },

    createUpdateOfferWithConfirmation() {
      notifier.deleteSenderNotifications(this);

      const updateOfferDefInputReport = this.getUpdateOfferDefInputReport();

      if(updateOfferDefInputReport.error !== null) {
        notifier.showError(updateOfferDefInputReport.error.message, {sender: this});
        return;
      }

      const updateOfferDef = updateOfferDefInputReport.updateOfferDef;
      if(updateOfferDef === null) {
        notifier.showError('Invalid input report. updateOfferDef === null.', {sender: this});
        return;
      }

      this.confirmUpdateOfferCreation(() => {
        this.createUpdateOffer(updateOfferDef);
      });
    },

    getUpdateOfferDefInputReport() {
      const plannedStartSec = this.plannedStartSec;
      if(plannedStartSec === null) {
        return new UpdateOfferDefInputReport(
          null,
          new Error('Start time must be specified.')
        );
      }

      const plannedFinishSec = this.plannedFinishSec;
      if(plannedFinishSec === null) {
        return new UpdateOfferDefInputReport(
          null,
          new Error('Finish time must be specified.')
        );
      }

      if(plannedFinishSec === plannedStartSec) {
        return new UpdateOfferDefInputReport(
          null,
          new Error('Contest duration is zero.')
        );
      }

      const trimmedClientMinVersion = this.clientMinVersion.trim();
      if(trimmedClientMinVersion.length === 0) {
        return new UpdateOfferDefInputReport(
          null,
          new Error('Client min version must be specified.')
        );
      }

      const trimmedClientMaxVersion = this.clientMaxVersion.trim();
      if(trimmedClientMaxVersion.length === 0) {
        return new UpdateOfferDefInputReport(
          null,
          new Error('Client min version must be specified.')
        );
      }

      const updateOfferDef = new UpdateOfferDef(
        this.selectedPlatforms,
        plannedStartSec,
        plannedFinishSec,
        trimmedClientMinVersion,
        trimmedClientMaxVersion,
        this.selectedPlace,
        this.title,
        this.iconUrlRoot + this.iconUrl,
        this.imageUrlRoot + this.imageUrl,
        this.selectedType
      );
      return new UpdateOfferDefInputReport(updateOfferDef, null);
    },

    /**
     * @param {ConfirmHandle} onConfirmed
     */
    confirmUpdateOfferCreation(onConfirmed) {
      confirmAction(
        this,
        'Are you sure you want to create this update offer {env}?',
        'Create',
        onConfirmed,
      );
    },

    /**
     * @param {UpdateOfferDef} updateOfferDef
     */
    createUpdateOffer(updateOfferDef) {
      const data = new FormData();
      data.set('platforms',          updateOfferDef.platforms);
      data.set('stime',              updateOfferDef.plannedStartSec.toString());
      data.set('ftime',              updateOfferDef.plannedFinishSec.toString());
      data.set('client_min_version', updateOfferDef.clientMinVersion);
      data.set('client_max_version', updateOfferDef.clientMaxVersion);
      data.set('icon_place',         updateOfferDef.iconPlace);
      data.set('title',              updateOfferDef.title);
      data.set('icon_url',           updateOfferDef.iconUrl);
      data.set('image_url',          updateOfferDef.imageUrl);
      data.set('type',               updateOfferDef.type);

      HTTP.post('/update_offer/add', data)
      .then(response => {
        const result = response.data.result;

        const RESULT_SUCCESS = 1;
        if(result.code === RESULT_SUCCESS) {
          notifier.showSuccessAfterTransition('Update Offer created.');
          this.$router.push({name: 'update_offers'});
          return;
        }

        notifier.showError(result.message, {sender: this});
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};

class UpdateOfferDefInputReport {
  constructor(updateOfferDef, error) {
    this.updateOfferDef = updateOfferDef;
    this.error     = error;
  }
}

class UpdateOfferDef {
  constructor(platforms, plannedStartSec, plannedFinishSec, clientMinVersion, clientMaxVersion, iconPlace, title, iconUrl, imageUrl, type) {
    this.platforms         = platforms.reduce((a, b) => a | b, 0);
    this.plannedStartSec   = plannedStartSec;
    this.plannedFinishSec  = plannedFinishSec;
    this.clientMinVersion  = clientMinVersion;
    this.clientMaxVersion  = clientMaxVersion;
    this.iconPlace         = iconPlace;
    this.title             = title;
    this.iconUrl           = iconUrl;
    this.imageUrl          = imageUrl;
    this.type              = type;
  }
}
</script>

<style scoped>
.client-min-version-range td:first-child {
  padding-right: 0.3rem;
}
</style>
